// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"489":"709a1f28efbf9d82e4fd","524":"8ec50e07c80a97b0646f","810":"de1ee78d2e19dc07e2e0"}[chunkId] + ".css";
};